module.exports = __webpack_public_path__ + "static/media/balanco2.f08332aa.jpeg";